import BannerApi from './BannerApi';
export default BannerApi;
